import { lazy } from "react";

const SystemBetaAccessRequestsPage = lazy(
  () => import("@/widgets/system-admin/beta-access/BetaAccessRequestsPage"),
);

const SystemBetaAccessRoutes = {
  path: "beta-requests",
  children: [{ index: true, element: <SystemBetaAccessRequestsPage /> }],
};

export default SystemBetaAccessRoutes;
